import DetailCard from '../../tracking/DetailCard'
import StatusCard from '../../tracking/StatusCard'
import { makeStyles, Link as MuiLink } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
    maxWidth: '100%',
    padding: theme.spacing(1),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    overflowY: 'scroll',
    overflowX: 'hidden',
  },
  spacer: {
    height: theme.spacing(1),
  },
}))

const TrackingInfoResult = ({ data, resetWidget }) => {
  const classes = useStyles()

  return (
    <div className={classes.root}>
      <DetailCard data={data} />
      <div className={classes.spacer} />
      <StatusCard data={'state' in data ? data.state : undefined} forceMobile />
      <MuiLink onClick={resetWidget}>{'< ตรวจสอบสถานะสินค้าอื่น'}</MuiLink>
    </div>
  )
}

export default TrackingInfoResult
